import React from 'react';
import numeral from 'numeral';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import InputComponent from '../../shared_components/InputComponent';
import ToggleComponent from '../../shared_components/ToggleComponent';
import InformationBoxComponent from '../../shared_components/InformationBoxComponent';


@observer
class ComparisonMortgageFormComponent extends React.Component {
  constructor(props) {
    super(props);

    this.setHouseValue = this.setHouseValue.bind(this);
    this.setDesiredMortgage = this.setDesiredMortgage.bind(this);
    this.showTextBox = this.showTextBox.bind(this);
  }

  setHouseValue(e) {
    const value = e.target.value;
    this.props.ComparisonFormData.setHouseValue(value);
  }

  setDesiredMortgage(e) {
    const value = e.target.value;
    this.props.ComparisonFormData.setDesiredMortgage(value);
    this.props.ComparisonFormData.setLoanparts();
  }

  showTextBox(data, event) {
    event.stopPropagation();
    this.props.ModalData.openModal(data);
  }

  render() {
    const { nhg, houseValue, mortgage, toggleNHG } = this.props.ComparisonFormData;
    const { informationBoxData } = this.props.InformationBoxData;

    const currencyEnabled = true;

    return (
      <div className="row columns comparison-mortgage-form">
        <InputComponent
          currency={currencyEnabled}
          placeholder="Waarde woning"
          value={houseValue}
          label="Waarde woning"
          classNames="medium-21 columns"
          onChange={this.setHouseValue}
        >
          <InformationBoxComponent
            classNames="info-box-input"
            onClickHandler={(event) => { this.showTextBox(informationBoxData.houseValue, event); }}
          />
        </InputComponent>
        <InputComponent
          currency={currencyEnabled}
          placeholder="Gewenste hypotheek"
          value={mortgage}
          label="Gewenste hypotheek"
          classNames="medium-21 columns"
          onChange={this.setDesiredMortgage}
        >
          <InformationBoxComponent
            classNames="info-box-input"
            onClickHandler={(event) => { this.showTextBox(informationBoxData.mortgage, event); }}
          />
        </InputComponent>
        <ToggleComponent
          label="NHG"
          checked={nhg}
          id={'toggle-nhg'}
          classNames="medium-15 end columns toggle-nhg"
          handleInputChange={(e) => { toggleNHG(e); }}
        >
          <InformationBoxComponent
            classNames="info-box-toggle"
            onClickHandler={(event) => { this.showTextBox(informationBoxData.nhg, event); }}
          />
        </ToggleComponent>
      </div>
    );
  }
}

ComparisonMortgageFormComponent.propTypes = {
  ModalData: PropTypes.shape({
    openModal: PropTypes.func,
  }),
  InformationBoxData: PropTypes.shape({
    informationBoxData: PropTypes.shape({
      header: PropTypes.string,
      text: PropTypes.string,
    }),
  }),
  ComparisonFormData: PropTypes.shape({
    nhg: PropTypes.bool,
    houseValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    mortgage: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    loanparts: PropTypes.arrayOf(PropTypes.number),
    setLoanparts: PropTypes.func,
    toggleNHG: PropTypes.func,
    setHouseValue: PropTypes.func,
    setDesiredMortgage: PropTypes.func,
  }),
};

ComparisonMortgageFormComponent.defaultProps = {
  ModalData: {
    openModal: () => {},
  },
  InformationBoxData: {
    informationBoxData: {
      header: '',
      text: '',
    },
  },
  ComparisonFormData: {
    nhg: false,
    houseValue: 0,
    mortgage: 0,
    loanparts: [],
    toggleNHG: () => {},
    setHouseValue: () => {},
    setLoanparts: () => {},
    setDesiredMortgage: () => {},
  },
};

export default inject('ComparisonFormData', 'ModalData', 'InformationBoxData')(ComparisonMortgageFormComponent);
